import axios from 'axios'
const sha1 = require('js-sha1');

export default {
    check: (rfc) => axios.post('check', {rfc: rfc}, {headers: {'checksum': sha1(rfc)}}),
    getIssuedCfdis: (rfc, filters, page, options = {}) => axios.post('issued-cfdis', 
        {rfc: rfc, filters: filters, page: page, ...options},
        {headers: {'checksum': sha1(rfc)}}
    ),
    getReceivedCfdis: (rfc, filters, page, options = {}) => axios.post('received-cfdis', 
        {rfc: rfc, filters: filters, page: page, ...options},
        {headers: {'checksum': sha1(rfc)}}
    ),
    getIssuedKpis: (rfc, filters) => axios.post('issued-cfdis',
        {
            rfc: rfc,
            filters: filters,
            page: 1,
            include_data: false,
            include_fields: false,
            include_totals: false,
            include_counters: false,
            include_kpis: true,
        },
        {headers: {'checksum': sha1(rfc)}}
    ),
    getReceivedKpis: (rfc, filters) => axios.post('received-cfdis',
        {
            rfc: rfc,
            filters: filters,
            page: 1,
            include_data: false,
            include_fields: false,
            include_totals: false,
            include_counters: false,
            include_kpis: true,
        },
        {headers: {'checksum': sha1(rfc)}}
    ),
    getReceivedKpiDetail: (rfc, filters, detailKey) => axios.post('received-kpi-detail',
        {rfc: rfc, filters: filters, detail_key: detailKey},
        {headers: {'checksum': sha1(rfc)}}
    ),
    getPayableCfdis: (rfc, filters, page) => axios.post('payable-cfdis',
        {rfc: rfc, filters: filters, page: page},
        {headers: {'checksum': sha1(rfc)}}
    ),
    getReceivableCfdis: (rfc, filters, page) => axios.post('receivable-cfdis',
        {rfc: rfc, filters: filters, page: page},
        {headers: {'checksum': sha1(rfc)}}
    ),
    getPpdPaymentReconciliation: (rfc, period, nature, page = 1, filters = {}) => axios.post('ppd-payment-reconciliation',
        {rfc: rfc, period: period, nature: nature, page: page, filters: filters, payment_status: filters.payment_status},
        {headers: {'checksum': sha1(rfc)}}
    ),
    exportPpdPaymentReconciliation: (rfc, period, nature, filters = {}, sort = {}) => axios.post('ppd-payment-reconciliation/export',
        {
            rfc: rfc,
            period: period,
            nature: nature,
            filters: filters,
            payment_status: filters.payment_status,
            sort_key: sort.key,
            sort_direction: sort.direction,
        },
        {
            headers: {'checksum': sha1(rfc)},
            responseType: 'blob',
        }
    ),
    getDiotWorkpaper: (rfc, period) => axios.post('diot-workpaper',
        {rfc: rfc, period: period},
        {headers: {'checksum': sha1(rfc)}}
    ),
    saveDiotWorkpaper: (rfc, period, supplierSelections = {}, deletedSuppliers = []) => axios.post('diot-workpaper/save',
        {rfc: rfc, period: period, supplier_selections: supplierSelections, deleted_suppliers: deletedSuppliers},
        {headers: {'checksum': sha1(rfc)}}
    ),
    addManualDiotSupplier: (rfc, period, payload = {}) => axios.post('diot-workpaper/manual-supplier',
        {rfc: rfc, period: period, ...payload},
        {headers: {'checksum': sha1(rfc)}}
    ),
    deleteDiotWorkpaperSupplier: (rfc, period, providerRfc, providerName, supplierSelections = {}, deletedSuppliers = [], supplierKey = '') => axios.post('diot-workpaper/delete-supplier',
        {
            rfc: rfc,
            period: period,
            provider_rfc: providerRfc,
            provider_name: providerName,
            supplier_key: supplierKey,
            supplier_selections: supplierSelections,
            deleted_suppliers: deletedSuppliers,
        },
        {headers: {'checksum': sha1(rfc)}}
    ),
    recalculateDiotWorkpaper: (rfc, period) => axios.post('diot-workpaper/recalculate',
        {rfc: rfc, period: period},
        {headers: {'checksum': sha1(rfc)}}
    ),
    exportDiotWorkpaperExcel: (rfc, period, supplierSelections = {}, deletedSuppliers = []) => axios.post('diot-workpaper/export-excel',
        {
            rfc: rfc,
            period: period,
            supplier_selections: supplierSelections,
            deleted_suppliers: deletedSuppliers,
        },
        {
            headers: {'checksum': sha1(rfc)},
            responseType: 'blob'
        }
    ),
    exportDiotWorkpaperTxt: (rfc, period, supplierSelections = {}, deletedSuppliers = []) => axios.post('diot-workpaper/export-txt',
        {
            rfc: rfc,
            period: period,
            supplier_selections: supplierSelections,
            deleted_suppliers: deletedSuppliers,
        },
        {
            headers: {'checksum': sha1(rfc)},
            responseType: 'blob'
        }
    ),
    getPaymentRelatedDetail: (rfc, paymentCfdiId, documentUuid) => axios.post('cfdis/payment-related-detail',
        {rfc: rfc, payment_cfdi_id: paymentCfdiId, document_uuid: documentUuid},
        {headers: {'checksum': sha1(rfc)}}
    ),
    getCfdiRelationDetail: (rfc, sourceCfdiId, relatedUuid) => axios.post('cfdis/relation-detail',
        {rfc: rfc, source_cfdi_id: sourceCfdiId, related_uuid: relatedUuid},
        {headers: {'checksum': sha1(rfc)}}
    ),
    getCfdisFiltered: (filters) => axios.post('cfdis/filtered', filters),
    getReviewGraph: (rfc, filters) => axios.post('review-graph', 
        {rfc: rfc, filters: filters},
        {headers: {'checksum': sha1(rfc)}}
    ),
    getPeriods: () => axios.get('cfdis/periods'),
    getFields: (nature, tab) => axios.post('cfdis/get-fields', {nature: nature, group: tab}),
    setFields: (nature, group, data) => axios.post('cfdis/set-fields',
        {nature: nature, group: group, data: data}
    ),
    getFilters: (nature, group) => axios.post('cfdis/get-filters', {nature: nature, group: group}),
    getTaxesSummary: (rfc, period, reportType = 'flujo') => axios.post('taxes/summary',
        {rfc: rfc, filters: {period: period, reportType: reportType}},
        {headers: {'checksum': sha1(rfc)}}
    ),
    getCreditableBreakdown: (rfc, filters) => axios.post('taxes/creditable-breakdown',
        {rfc: rfc, filters: filters},
        {
            headers: {'checksum': sha1(rfc)},
            skipLoading: true,
        }
    ),
    getTransferredBreakdown: (rfc, filters) => axios.post('taxes/transferred-breakdown',
        {rfc: rfc, filters: filters},
        {
            headers: {'checksum': sha1(rfc)},
            skipLoading: true,
        }
    ),
    checkDownloads: (rfc, period, nature) => axios.post('cfdis/check-downloads', {rfc: rfc, period: period, nature: nature}, {headers: {'checksum': sha1(rfc)}}),
    downloadCfdis: (rfc, period) => axios.post('cfdis/download', 
        {rfc: rfc, period: period, nature: 'all'},
        {headers: {'checksum': sha1(rfc)}}
    ),
    synchronizeCfdis: (rfc, period) => axios.post('cfdis/synchronize', 
        {rfc: rfc, period: period, nature: 'status'},
        {headers: {'checksum': sha1(rfc)}}
    ),
    getCfdiDetail: (rfc, uuid) => axios.post('cfdis/detail',
        {rfc: rfc, uuid: uuid},
        {headers: {'checksum': sha1(rfc)}}
    ),
    getCfdiRelations: (rfc, uuid) => axios.post('cfdis/relations',
        {rfc: rfc, uuid: uuid},
        {headers: {'checksum': sha1(rfc)}}
    ),
    getCfdiPaymentRelations: (rfc, uuid) => axios.post('cfdis/payment-relations',
        {rfc: rfc, uuid: uuid},
        {headers: {'checksum': sha1(rfc)}}
    ),
    markCfdiAsPaid: (rfc, uuid) => axios.post('cfdis/mark-as-paid',
        {rfc: rfc, uuid: uuid},
        {headers: {'checksum': sha1(rfc)}}
    ),
    validateCfdiStatusNow: (rfc, uuid) => axios.post('cfdis/validate-status-now',
        {rfc: rfc, uuid: uuid},
        {headers: {'checksum': sha1(rfc)}}
    ),
    requestCfdiStatusRefresh: (rfc, uuid) => axios.post('cfdis/request-status-refresh',
        {rfc: rfc, uuid: uuid},
        {headers: {'checksum': sha1(rfc)}}
    ),
    getCfdiStatusRefreshState: (rfc, uuid) => axios.post('cfdis/status-refresh-state',
        {rfc: rfc, uuid: uuid},
        {headers: {'checksum': sha1(rfc)}}
    ),
    exportCfdis: (rfc, filters, fields = []) => axios.post('cfdis/export',
        {rfc: rfc, filters: filters, fields: fields},
        {
            headers: {'checksum': sha1(rfc)},
            responseType: 'blob'
        }
    ),
    requestCfdiFilesDownload: (rfc, nature, filters, config = {}) => axios.post('download-center/cfdi-files/request',
        {rfc: rfc, nature: nature, filters: filters},
        {
            headers: {'checksum': sha1(rfc), ...(config.headers || {})},
            ...config,
        }
    ),
}

